import { getEntityNameFromRoute as getEntityNameFromRouteName } from '~/cynqueModules/getEntityNameFromRoute'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  // Provides `this.$getEntityNameFromRoute()` (components). Pure logic lives in
  // cynqueModules/getEntityNameFromRoute so the nuxtRuntime context shim can
  // reuse it for asyncData.
  function getEntityNameFromRoute() {
    return getEntityNameFromRouteName(
      router.currentRoute.value.name?.toString()
    )
  }
  return { provide: { getEntityNameFromRoute } }
})
